// extracted by mini-css-extract-plugin
export default {"modal-header":"AddDocument_modal-header__rRFh0","modal-header-filter":"AddDocument_modal-header-filter__PLBdA","modal-title":"AddDocument_modal-title__xtoDR"};